import en from 'vuetify/es5/locale/en'

export default {
  ...en,

  common:{
    search: "Search"
  },
  actions: {
    more: "More",
  },
  appbar: {
    
  }
}